import { logEvent } from "utils/analytics";

// Fires `playback_started` once per play start of a WEB player's media element: the first
// "playing" event after load/ended/source change. Resume after pause, seeks and rebuffering
// re-emit "playing" but are ignored. Never call this for a native-handed-off player: the
// native app fires the same event with source "native_player".
export function trackPlaybackStarted(media, contentType) {
  if (!media || media.supercastPlaybackTracked) return;
  media.supercastPlaybackTracked = true;

  let started = false;
  media.addEventListener("playing", () => {
    if (started) return;
    started = true;
    const properties = { source: "web_player" };
    if (contentType) properties.content_type = contentType;
    logEvent("playback_started", properties);
  });
  const reset = () => { started = false; };
  media.addEventListener("ended", reset);
  media.addEventListener("emptied", reset);
}
